import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

export const ArrowUp = (props: SvgIconProps) => (
    <SvgIcon {...props} style={{ transform: 'rotate(-90deg)' }}>
        <path
            id="arrow-down-a"
            d="M7.033 1.243a.917.917 0 00-1.266.022.9.9 0 00-.022 1.256l10.848 9.648-10.848 9.31a.9.9 0 00.022 1.256.917.917 0 001.266.022l11.452-10.132c.171-.152.22-.456.22-.456s-.063-.327-.241-.49L7.034 1.243z"
        />
    </SvgIcon>
);

export default ArrowUp;
